export class SSOUtil {
    static isIos(isMacLike:  boolean, isIOSLike: boolean): boolean {
        let majorVersion, minorVersion, osVersion, osNameAndVersion, versionPosition;
        majorVersion = 0;
        minorVersion = 0;
        if (navigator.userAgent && navigator.userAgent.split(')') && navigator.userAgent.split(')').length > 0) {
            osNameAndVersion = navigator.userAgent.split(')')[0];
            versionPosition = 1;
            if (osNameAndVersion && osNameAndVersion.indexOf('like') > -1) {
                 versionPosition = 5;
                }
            if (osNameAndVersion && osNameAndVersion.split(' ') && osNameAndVersion.split(' ').length > 0) {
                osVersion = osNameAndVersion.split(' ')[osNameAndVersion.split(' ').length - versionPosition];
                if (osVersion && osVersion.split('_') && osVersion.split('_').length > 0) {
                    majorVersion = parseInt(osVersion.split('_')[0], 10);
                    if (osVersion.split('_').length > 1) {
                        minorVersion = parseInt(osVersion.split('_')[1], 10);
                    }
                }
            }
        }
        if ((isMacLike && ((majorVersion >= 10 && minorVersion >= 15) || majorVersion >= 11 )) || (isIOSLike && majorVersion >= 13)) {
            return true;
        }
        return false;
    }
}
